import { components } from 'react-select';
import { SelectControl as Control } from './_Control/SelectControl';
import { SelectValueContainer as ValueContainer } from './_ValueContainer/SelectValueContainer';
import { SelectDefaultOption as Option } from './_Option';
import { SelectSingleValue as SingleValue } from './_SingleValue/SelectSingleValue';
import { SelectDropdownIndicator as DropdownIndicator } from './_DropdownIndicator/SelectDropdownIndicator';
import { SelectMenuPortal as MenuPortal } from './_MenuPortal/SelectMenuPortal';
import { SelectMenuList as MenuList } from './_MenuList/SelectMenuList';
import { SelectMultiValue as MultiValue } from './_MultiValue/SelectMultiValue';
import { SelectMenu as Menu } from './_Menu/SelectMenu';
import { SelectClearIndicator as ClearIndicator } from './_ClearIndicator/SelectClearIndicator';
import { SortableMultiValue } from './_MultiValue/_SortableMultiValue/SortableMultiValue';
import { SelectInput as Input } from './_Input/SelectInput';
import { SelectIndicatorsContainer as IndicatorsContainer } from './_IndicatorsContainer/IndicatorsContainer';
import { SelectPlaceholder as Placeholder } from './_Placeholder/SelectPlaceholder';

export const DEFAULT_COMPONENTS = {
  ...components,
  Control,
  Input,
  ValueContainer,
  DropdownIndicator,
  Option,
  SingleValue,
  MultiValue,
  Placeholder,
  MenuPortal,
  Menu,
  MenuList,
  ClearIndicator,
  IndicatorsContainer,
  IndicatorSeparator: null,
};

export const DRAG_AND_DROP_COMPONENTS = {
  ...DEFAULT_COMPONENTS,
  MultiValue: SortableMultiValue,
};
